import { Charts } from './Charts';
import BirthChartsDataProvider from './contexts/BirthChartsDataContext';

const BirthWrapper = () => {
    return (
        <BirthChartsDataProvider>
            <Charts />
        </BirthChartsDataProvider>
    );
};

export default BirthWrapper;
